<template>
  <div class="container z-flex">
    <div class="main-con z-flex z-flex-col">
      <div class="main-box" ref="mainBox">
        <div class="writing-box z-flex z-flex-col">
          <img class="logo-icon" src="../assets/images/logo.png"/>
          <div class="logo">AI摄影秘书</div>
          <div class="writing-menu z-flex z-flex-between">
            <div 
              class="item z-flex" 
              v-for="(item, index) in menuList" 
              :key="index" 
              @click="$myFun.toUrl(`${item.url}?index=${index+1}&title=${item.title}`)"
            >
              <img class="icon" :src="item.icon"/>
              <div class="text">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
	  
  },
  data() {
    return {
      menuList:[
        {
          icon:require('@/assets/images/icon-1.png'),
          title:'摄影技巧解答',
          desc:'强大的摄影技巧，提高创作效率',
          url:'/answers',
        },
        {
          icon:require('@/assets/images/icon-2.png'),
          title:'摄影文章编写',
          desc:'简单描述，快速完成文章撰写',
          url:'/articles',
        },
        {
          icon:require('@/assets/images/icon-3.png'),
          title:'摄影创作思路',
          desc:'提供创作灵感，延伸创作思想',
          url:'/answers',
        },
        {
          icon:require('@/assets/images/icon-4.png'),
          title:'摄影诗歌散文',
          desc:'一键智能，自动生成摄影美文',
          url:'/poetry',
        },
      ],
    };
  },
  mounted() {

  },
  created() {
    
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.writing-box{
  width: 1000px;
  margin: 0 auto;
  .logo-icon{
    width:100px;
    margin:50px 0 10px;
  }
  .logo{
    font-size: 28px;
    letter-spacing: 2px;
    margin-bottom: 40px;
  }
  .writing-menu{
    width:100%;
    .item{
      width:calc(50% - 10px);
      margin-bottom: 20px;
      border: $border;
      background: $colorBgLight;
      border-radius: 6px;
      padding: 20px 40px;
      box-sizing: border-box;
      cursor: pointer;
      .icon{
        width: 80px;
        height: 80px;
        margin-right: 30px;
      }
      .title{
        font-size: 20px;
        color: #fff;
        margin-bottom: 10px;
      }
      .desc{
        color: #ccc;
        font-size: 14px;
      }
      &:hover{
        border-color:$colorMain;
      }
    }
  }
}
</style>
